<script>
	import ButtonViewsXpages from './componentes/ButtonViewsXpages.svelte';
	import Helper from './components/Helper.svelte';
  import { viewsXpages, registerXpage, urlapp } from './stores/store.js'; // CAMBIO AGREGAR quitar duplicado  
  import BotonOrder from './componentes/BotonOrder.svelte'; // CAMBIO AGREGAR 
  import { fade, fly } from 'svelte/transition';
  import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';  
  import { push } from 'svelte-spa-router';
  import AnimationContainer from './components/AnimationContainer.svelte';
  import Navbar from './components/Navbar.svelte';
  import Titlesection from "./components/Titlesection.svelte";
  import { autentificado, prefix, urlapi, login,miPermiso,iduser } from './stores/store';

  import DatagridRow from './componentes/DatagridRow.svelte';
  import DatagridTitle from './componentes/DatagridTitle.svelte';
  import DatagridCell from './componentes/DatagridCell.svelte';
  import Datagrid from './componentes/Datagrid.svelte';

  import Infopagination from './components/Infopagination.svelte';
  import Pagination from './components/Pagination.svelte';
  import Searchsection from "./components/Searchsection.svelte";
  import { object2array, postData, verifyAccess } from './scripts';

  import moment from 'moment';

  //verifyAccess($login,$miPermiso,'clientes','access')

  /* PERMISOS */
  let viewPage=false;

  if($login===false)
  {
      push('/login')
  } else if( $miPermiso.lotes.access===false ) {
      push('/sinpermiso')
  } else {
      viewPage=true;
  }
  /* FIN PERMISOS */

  let avanzado=false;
  let uid=null; // CAMBIO AGREGAR VARIABLE
  const res=null;
  let datagrid=[]
  let cargando=false;
  let pageActual=0;
  let dataPagination={};
  let searchText='';
  let orderField='id';
  let orderDir='ASC';
  
  let offcanvas_etiquetas=false;
  let Bsoffcanvas_etiquetas=false;

    function eventPage(event)
  {
      pageActual=event.detail.text;
      loadData()
  }

  function eventSearch(event)
  {
      pageActual=0;
      searchText=event.detail.text
      loadData()
  }

  function eventText()
  {
      pageActual=0;
      loadData()
  }

  async function loadData()
  {
      /*dataPagination=false;
      return [];*/
      cargando=true;

      let datos={ 
          'cmd': "lotes_list",
          pagination: $viewsXpages,
          page: pageActual,
          order: orderField,
          dir: orderDir }

      if(avanzado===true)
      {
          if(searchText!='') datos={...datos, 'search':searchText }
      }
      
      const res = await postData($urlapi, [datos])
      .then(data => {
          datagrid= object2array(data[0].result);
          dataPagination=data[0].pagination;
          cargando=false;
      });
      
  }

  let edit= function(id) { push('/lotes/'+id); }
  let nuevo=function () { push('/lotes/new') }
  let eliminar=function() {
        /*postData($urlapi, [{ 
            'cmd':'clientes_delete',
            'id':seleccionado,
        }]).then(data => {
            pageActual=0;
            loadData()
        });*/
  }

  let loteSeleccionadoImpresion=false;
  let loteproductoImpresion='';
  //let loteproductosImpresion=[{'0':'Sin Filtrar'},{'A':'ANULADA'},{'E':'EMITIDA'}];
  let loteproductosImpresion=[];

    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, '0')
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = currentDate.getFullYear();

  let lotefechaImpresion='';
  let loteproductoImpresionCantidad=1;
  let objectErrorEtiquetas=null;



  let printEtiqueta = function(id) {

        loteSeleccionadoImpresion=id;
        loteproductoImpresionCantidad=1;
        lotefechaImpresion=`${year}-${month}-${day}`;

        postData($urlapi, [{'cmd':'lotes_edit','idlote':id,'user':{ 'iduser':$iduser }}])
        .then(data => {
           
            loteproductosImpresion=[];
            loteproductoImpresion='';


            loteproductosImpresion.push({'':'Seleccione Producto'});

            let objectTMP={};
            
            object2array(data[0].productos).forEach((element) => {
                objectTMP={};
                objectTMP[element.codart]=`[${element.codart}] ${element.descripcion}`;
                loteproductosImpresion.push(objectTMP);
            });

            Bsoffcanvas_etiquetas = new bootstrap.Offcanvas(offcanvas_etiquetas)
            Bsoffcanvas_etiquetas.show()
        });
  }

  function ImprimirEtiquetas()
  {
        if(loteproductoImpresionCantidad===null) loteproductoImpresionCantidad=1;

        if(loteproductoImpresion=='')
        {
            objectErrorEtiquetas.innerHTML=`<div class="alert alert-danger" role="alert">
            <i class="bi bi-exclamation-triangle me-1"></i>Seleccione el producto
            </div>`
        } else if(moment(lotefechaImpresion, 'YYYY-MM-DD').isValid()===false) {
            objectErrorEtiquetas.innerHTML=`<div class="alert alert-danger" role="alert">
            <i class="bi bi-exclamation-triangle me-1"></i>Seleccione una fecha correcta
            </div>`            
        } else {
            objectErrorEtiquetas.innerHTML='';

            let get_etiqueta='';
            get_etiqueta+=`?idlote=`+loteSeleccionadoImpresion;
            get_etiqueta+=`&codigo=`+loteproductoImpresion;
            get_etiqueta+=`&cantidad=`+loteproductoImpresionCantidad;
            get_etiqueta+=`&fecha=`+lotefechaImpresion;
            window.open($urlapp+'print/lote_etiquetas.php'+get_etiqueta);
            closeImprimirEtiquetas()            

        }



  }

  function closeImprimirEtiquetas()
  {
        Bsoffcanvas_etiquetas.hide()
  }

  /*setTimeout(() => {
    printEtiqueta(25)
  }, 500);*/

  
  let printDetalleLote= function(id) {
        window.open(`${$urlapp}print/lote.php?idlote=${id}`);
  }
  


  function orderTable(event) {
        if(cargando===false) {
          pageActual=0;
          orderField=event.detail.order;
          orderDir=event.detail.dir;
          loadData()
        }
  }

  let helper=false;

  let seleccionado=false;
  let selected= function (event) { 
      if(seleccionado==false || seleccionado!==event.detail.id) {
        seleccionado=event.detail.id
      } else {
        seleccionado=false
      }
  }

</script>

{#if viewPage===true}

<Navbar />

<AnimationContainer>
    <Titlesection>
        <span slot="title"><i class="bi bi-boxes me-1" />Lotes</span>
        <span slot="toolbar">

          {#if $miPermiso.lotes.insert===true}
              <button class='btn btn-primary' on:click={nuevo} on:mouseenter={()=>helper='Crear Registro'} on:mouseleave={()=>helper=false}><i class="bi bi-plus-circle"></i></button>
          {/if}

          {#if $miPermiso.lotes.delete===true}
              <Modal classButton='btn-danger' iconButton='bi-trash' functionSi={eliminar} title='ADVERTENCIA' disabled={!seleccionado}  on:mouseenter={()=>helper='Eliminar Registro'} on:mouseleave={()=>helper=false}>
                Esta seguro que desea <strong>Eliminar</strong> el registro?<br/>Se perderán todos los datos.
              </Modal>
          {/if}

          {#if $miPermiso.lotes.edit===true}
              <span on:mouseenter={()=>helper='Ver Registro'} on:mouseleave={()=>helper=false}><button disabled={!seleccionado} class='btn btn-success' on:click={()=>edit(seleccionado)}><i class="bi bi-binoculars"></i></button></span>
          {/if}

          {#if $miPermiso.lotes.edit===true}
              <span on:mouseenter={()=>helper='Imprimir Etiquetas'} on:mouseleave={()=>helper=false}><button disabled={!seleccionado} class='btn btn-warning' on:click={()=>printEtiqueta(seleccionado)}><i class="bi bi-tags"></i></button></span>
          {/if}

          {#if $miPermiso.lotes.edit===true}
              <span on:mouseenter={()=>helper='Imprimir Detalle Lote'} on:mouseleave={()=>helper=false}><button disabled={!seleccionado} class='btn btn-info' on:click={()=>printDetalleLote(seleccionado)}><i class="bi bi-printer"></i></button></span>
          {/if}          

          {#if avanzado===false}
            <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
          {:else}
            <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
          {/if}

          <ButtonViewsXpages on:load={()=>{pageActual=0; loadData();}} on:mouseenter={()=>helper='Registros por página'} on:mouseleave={()=>helper=false}/>

          <BotonOrder uid={uid} on:mouseenter={()=>helper='Ordenar'} on:mouseleave={()=>helper=false} />
        </span>
    </Titlesection>

    {#if avanzado===true}
    <div class="container-fluid mt-1" in:fly={{y:-10,duration:500}}>
        <div class="row">

            <div class='col-12 mb-2 mt-2'>
                <Input label='Filtrar por ID, REFERENCIA, PROVEEDOR' bind:value={searchText} on:change={eventText} />
            </div>          
        </div>
    </div>
    {/if}

    <!-- DATA GRID -->
    <div class="container-fluid mt-2">
    <div class="row">
        <div class="col-12">

            <Datagrid bind:uid={uid} order={orderField} dir={orderDir} on:order={orderTable}>

                <svelte:fragment slot="header">
                    <DatagridTitle width='100px' order="id" title='ID'/>
                    <DatagridTitle order="fechaIngreso" title='Fecha Ingreso'/>
                    <DatagridTitle order="fechaLote" title='Fecha Lote'/>
                    <DatagridTitle order="nreferencia" title='Referencia'/>
                    <DatagridTitle order="proveedor" title='Proveedor'/>
                    <DatagridTitle order="status" title='Estatus'/>
                </svelte:fragment>
                <svelte:fragment slot="body">
                {#each datagrid as item}
                <DatagridRow id={item.id} bind:seleccionado={seleccionado} on:select={selected}>
                        <DatagridCell title='ID'>{item.id}</DatagridCell>
                        <DatagridCell title='Fecha Ingreso' primary>{moment(item.fechaIngreso).format('DD/MM/YYYY')}</DatagridCell>
                        <DatagridCell title='Fecha Lote'>{moment(item.fechaLote).format('DD/MM/YYYY')}</DatagridCell>
                        <DatagridCell title='Referencia'>{item.nreferencia}</DatagridCell>
                        <DatagridCell title='Proveedor'>{item.proveedor}</DatagridCell>
                        <DatagridCell title='Status'>
                            {#if item.status=='E'}
                                <span class='badge bg-success fw-bold'>Emitido</span>
                            {:else if item.status=='A'}
                                <span class='badge bg-danger fw-bold'>Anulado</span>
                            {/if}
                        </DatagridCell>
                </DatagridRow>
                {/each}
                
                </svelte:fragment>
            </Datagrid>

        </div>
    </div>
    </div>

    <!-- PAGINACIÓN -->
    <div class="container mt-3">
    <div class="row">
        <div class="col-12 col-md-6 text-end text-md-start">
        <Infopagination data={dataPagination}/>
        </div>
        <div class="col-12 col-md-6">
        <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
        </div>
    </div>
    </div>

    <!-- OFFCANVAS CORTE -->
    <div class="offcanvas offcanvas-end" style='width:700px;' bind:this={offcanvas_etiquetas} tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
            <h5 id="offcanvasRightLabel">Impresión Etiquetas por lotes</h5>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body pt-0">
            <div class="container-fluid border-top border-bottom pt-2 pb-2">
                <div class="row ">
                    <div class='col-12 mb-2'>
                        Lote seleccionado: <strong class='text-warning'>{loteSeleccionadoImpresion}</strong>
                        <!-- <Input label='Fecha de Corte' bind:value={fecha_cortedia} tipo='date'/> -->
                    </div>

                    <div class='col-12 mb-2'>
                        <Input label='' bind:value={loteproductoImpresion} tipo='select' datos={loteproductosImpresion} />
                    </div>

                    <div class='col-12 mb-2'>
                        <Input label='' bind:value={loteproductoImpresionCantidad} tipo='number' />
                    </div>

                    <div class='col-12 mb-2'>
                        <Input label='' bind:value={lotefechaImpresion} tipo='date' />
                    </div>

                    <div bind:this={objectErrorEtiquetas}></div>

                    <div class='col-12'>
                        <button class='btn btn-success' on:click={ImprimirEtiquetas} on:mouseenter={()=>helper=''} on:mouseleave={()=>helper=false}><i class="bi bi-tags me-1"></i>Imprimir</button>
                        <button class='btn btn-danger' on:click={closeImprimirEtiquetas} on:mouseenter={()=>helper=''} on:mouseleave={()=>helper=false}><i class="bi bi-arrow-return-left me-1"></i> Salir</button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <Helper bind:text={helper}></Helper>

</AnimationContainer>

{/if}